import * as PIXI from "pixi.js";

export default class PageGL {
    constructor() {
        this.assets = {};
        this.textures = {};
        this._init();
    }

    load(callback = null) {
        this.callback = callback;
        this._loadAssets();
    }

    get _texures() {
        return this.textures;
    }

    _init() {
        this.assets = {
            kv_bg: "/assets/img/top/mv/kv_bg.png",
            kv_chara1: "/assets/img/top/mv/kv_chara1.png",
            kv_chara2: "/assets/img/top/mv/kv_chara2.png",
            bg: "/assets/img/common/pagemask_texture.png",
            mask: "/assets/img/common/logo_mask.png",
            noise: "/assets/img/common/noise.png",
            pv1: "/assets/img/top/pv/img1.png",
            pv2: "/assets/img/top/pv/img2.png",
            pv2_en: "/assets/img/top/pv/img2_en.png",
            pv3: "/assets/img/top/pv/img3.png",
            pv4: "/assets/img/top/pv/img4.png",
            gradation: "/assets/img/common/mask_grad.png",
        };
    }

    _loadAssets() {
        const keys = [];

        Object.keys(this.assets).forEach((key) => {
            PIXI.Assets.add(key, this.assets[key]);
            keys.push(key);
        });

        const texPromise = PIXI.Assets.load(keys);
        texPromise.then((textures) => {
            this.textures = textures;
            this.callback();
        });
    }
}
